<template>
  <v-container class="grey-lighten-3 full-height">

    <v-row justify="center">

      <v-col cols="12" xl="10">

        <v-sheet
          class="report-paper pa-6"
          elevation="3"
          id="printable-area"
        >

          <!-- WATERMARK -->
          <div
            class="watermark"
            v-if="priceInquiryDetails?.branch?.company?.watermark && invoiceHeader"
          >

            <img
              :src="`${getFileServerUrl}${priceInquiryDetails?.branch?.company?.watermark}`"
              alt=""
            >

          </div>

          <div class="invoice-container">

            <div class="invoice-content">

              <table
                style="width: 100%; border-collapse: collapse;"
              >

                <!-- HEADER IMAGE -->
                <thead>

                  <tr
                    v-if="priceInquiryDetails?.branch?.company?.header_image && invoiceHeader"
                  >

                    <td colspan="100%">

                      <img
                        :src="`${getFileServerUrl}${priceInquiryDetails?.branch?.company?.header_image}`"
                        style="width: 100%;"
                        alt=""
                      >

                    </td>

                  </tr>

                </thead>

                <tbody>

                  <!-- DEFAULT HEADER -->
                  <tr
                    v-if="!priceInquiryDetails?.branch?.company?.header_image && invoiceHeader"
                  >

                    <td colspan="100%">

                      <div class="page-header">

                        <div
                          class="header-section d-flex justify-space-between align-start"
                        >

                          <!-- COMPANY INFO -->
                          <div class="company-info">

                            <h4 class="company-name">
                              {{
                                priceInquiryDetails?.branch?.company?.name || ''
                              }}
                            </h4>

                            <p class="company-text">
                              {{
                                priceInquiryDetails?.branch?.company?.address || ''
                              }}
                            </p>

                            <p class="company-text">

                              <v-icon size="small">
                                mdi-phone-outline
                              </v-icon>

                              {{
                                priceInquiryDetails?.branch?.company?.mobile || ''
                              }}

                            </p>

                            <p class="company-text">

                              <v-icon size="small">
                                mdi-email-outline
                              </v-icon>

                              {{
                                priceInquiryDetails?.branch?.company?.email || ''
                              }}

                            </p>

                          </div>

                          <!-- LOGO -->
                          <div class="logo-container">

                            <v-img
                              :src="`${getFileServerUrl}/${priceInquiryDetails?.branch?.company?.logo || 'uploads/demo_images/user.png'}`"
                              max-width="150"
                              max-height="70"
                              contain
                            />

                          </div>

                        </div>

                      </div>

                    </td>

                  </tr>

                  <!-- TITLE -->
                  <tr>

                    <td colspan="100%">

                      <div class="text-center my-6">

                        <h2 class="report-title">
                          PRICE INQUIRY DETAILS
                        </h2>

                      </div>

                    </td>

                  </tr>

                  <!-- MASTER INFO -->
                  <tr class="master-box-parent">

                    <td colspan="100%">

                      <div
                        class="master-box mt-4"
                        style="font-size: 9px;"
                      >

                        <table
                          class="dep-table table-borderd"
                          style="width:100%"
                        >

                          <tbody>

                            <tr>

                              <td width="40%">
                                <strong>Code</strong>
                              </td>

                              <td width="60%">
                                {{ priceInquiryDetails?.code }}
                              </td>

                            </tr>

                            <tr class="d-none">

                              <td>
                                <strong>Customer</strong>
                              </td>

                              <td>
                                {{
                                  priceInquiryDetails?.customer?.company_name || 'N/A'
                                }}
                              </td>

                            </tr>

                            <tr class="d-none">

                              <td>
                                <strong>Customer Mobile</strong>
                              </td>

                              <td>
                                {{
                                  priceInquiryDetails?.customer?.company_mobile || 'N/A'
                                }}
                              </td>

                            </tr>

                            <tr>

                              <td>
                                <strong>Lead</strong>
                              </td>

                              <td>
                                {{
                                  priceInquiryDetails?.lead ? (priceInquiryDetails?.lead?.code+'-'+priceInquiryDetails?.lead?.company_name) : 'N/A'
                                }}
                              </td>

                            </tr>

                            <tr>

                              <td>
                                <strong>Lead Mobile</strong>
                              </td>

                              <td>
                                {{
                                  priceInquiryDetails?.lead?.company_phone || 'N/A'
                                }}
                              </td>

                            </tr>

                            <tr class="d-none">

                              <td>
                                <strong>Representative</strong>
                              </td>

                              <td>
                                {{
                                  priceInquiryDetails?.representative?.name || 'N/A'
                                }}
                              </td>

                            </tr>

                            <tr>

                              <td>
                                <strong>Final Price</strong>
                              </td>

                              <td>
                                {{
                                  formatNumber(priceInquiryDetails?.final_price)
                                }}
                              </td>

                            </tr>

                            <tr>

                              <td>
                                <strong>Status</strong>
                              </td>

                              <td>
                                {{
                                  priceInquiryDetails?.status == 1
                                    ? 'Published'
                                    : 'Draft'
                                }}
                              </td>

                            </tr>

                            <tr>

                              <td>
                                <strong>Discussion</strong>
                              </td>

                              <td>
                                {{
                                  priceInquiryDetails?.discussion || '-'
                                }}
                              </td>

                            </tr>

                            <tr>

                              <td>
                                <strong>Clarification</strong>
                              </td>

                              <td>
                                {{
                                  priceInquiryDetails?.clarification || '-'
                                }}
                              </td>

                            </tr>

                          </tbody>

                        </table>

                      </div>

                    </td>

                  </tr>

                  <!-- DETAILS TABLE -->
                  <tr>

                    <td
                      colspan="100%"
                      class="details-table mt-6"
                    >

                      <div class="table-wrapper">

                        <table
                          class="dep-table mt-3 table-borderd details-table-custom"
                        >

                          <thead>

                            <tr>

                              <th>#SL</th>

                              <th>Product</th>

                              <th>Code</th>

                              <th>Net Weight</th>

                              <th>Gross Weight</th>

                              <th>CBM</th>

                              <th>Remarks</th>

                              <th>Attachment</th>

                              <th>Packing List</th>

                            </tr>

                          </thead>

                          <tbody>

                            <tr
                              v-for="(detail, index) in priceInquiryDetails?.details"
                              :key="detail.id"
                            >

                              <td class="text-center">
                                {{ ++index }}
                              </td>

                              <td>
                                {{
                                  detail?.product?.name || 'N/A'
                                }}
                              </td>

                              <td>
                                {{
                                  detail?.product?.code || 'N/A'
                                }}
                              </td>

                              <td class="text-right">
                                {{
                                  formatNumber(detail?.net_weight)
                                }}
                              </td>

                              <td class="text-right">
                                {{
                                  formatNumber(detail?.gross_weight)
                                }}
                              </td>

                              <td class="text-right">
                                {{
                                  formatNumber(detail?.cbm)
                                }}
                              </td>

                              <td>
                                {{
                                  detail?.remarks || '-'
                                }}
                              </td>

                              <!-- ATTACHMENT -->
                              <td class="text-center">

                                <a
                                  v-if="detail?.attachment"
                                  :href="`${getFileServerUrl}/${detail?.attachment}`"
                                  target="_blank"
                                >
                                  View File
                                </a>

                                <span v-else>
                                  N/A
                                </span>

                              </td>

                              <!-- PACKING -->
                              <td class="text-center">

                                <a
                                  v-if="detail?.attachment_packing_list"
                                  :href="`${getFileServerUrl}/${detail?.attachment_packing_list}`"
                                  target="_blank"
                                >
                                  View File
                                </a>

                                <span v-else>
                                  N/A
                                </span>

                              </td>

                            </tr>

                          </tbody>

                        </table>

                      </div>

                    </td>

                  </tr>

                </tbody>

                <tfoot>

                  <tr>

                    <td colspan="100%">

                      <div style="height: 100px;"></div>

                    </td>

                  </tr>

                </tfoot>

              </table>

            </div>

          </div>

        </v-sheet>

      </v-col>

    </v-row>

    <!-- PRINT BUTTON -->
    <v-row class="d-print-none mt-4">

      <v-col
        cols="12"
        class="d-flex justify-center"
      >

        <v-btn
          color="primary"
          prepend-icon="mdi-printer"
          @click="print(0)"
        >
          Print without pad
        </v-btn>

        <v-btn
          color="primary"
          class="ml-2"
          prepend-icon="mdi-printer"
          @click="print(1)"
        >
          Print with pad
        </v-btn>

      </v-col>

    </v-row>

  </v-container>
</template>

<script setup>
import {
  ref,
  onMounted,
  computed
} from "vue";

import {
  useStore
} from "vuex";

import {
  useRoute
} from "vue-router";

const store = useStore();

const route = useRoute();

const id = route.params.id;

const priceInquiryDetails = ref(null);

const invoiceHeader = ref(true);

const pagePadding = ref(0);

const getFileServerUrl = computed(() => {
  return store.getters.getFileServerUrl;
});

/* ================= FORMAT NUMBER ================= */

const formatNumber = (val) => {

  if (val == null) return '';

  return Number(val).toLocaleString(
    undefined,
    {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }
  );

};

/* ================= PRINT ================= */

const print = (isPad) => {

  invoiceHeader.value = isPad === 1;

  pagePadding.value = isPad === 1
    ? 0
    : 100;

  setTimeout(() => {

    const printContent =
      document.getElementById("printable-area").outerHTML;

    const printWindow =
      window.open("", "_blank");

    printWindow.document.write(`
      <html>
        <head>
          <title>Price Inquiry Details</title>

          <style>

            body {
              margin:0;
              font-family:sans-serif;
            }

            table {
              width:100%;
              border-collapse: collapse;
            }

            th,
            td {
              border:1px solid #000;
              padding:4px;
              font-size:10px;
            }

            th {
              background:#eee;
            }

            @page {
              size:A4;
              margin:${pagePadding.value}px 10px;
            }

          </style>

        </head>

        <body>

          ${printContent}

        </body>

      </html>
    `);

    printWindow.document.close();

    setTimeout(() => {

      printWindow.print();

      printWindow.close();

    }, 500);

  }, 300);

};

/* ================= LOAD DATA ================= */

onMounted(async () => {

  try {

    const res = await store.dispatch(
      "getPriceInquiryById",
      id
    );

    if (res?.success) {

      priceInquiryDetails.value =
        res.data;

    }

  } catch (error) {

    console.error(error);

  }

});
</script>

<style scoped>

.full-height {
  min-height: 60vh;
}

.grey-lighten-3 {
  background-color: #eeeeee;
}

.report-paper {
  background: white;
}

.invoice-content{
  width: 100%;
  overflow: hidden;
}

.company-name {
  font-size: 9px;
  font-weight: bold;
}

.company-text {
  font-size: 9px;
}

.report-title {
  font-size: 16px;
  text-align: center;
}

.dep-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 9px;
}

.dep-table th,
.dep-table td {
  border: 1px solid #000;
  padding: 3px;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  opacity: 0.1;
  transform: translate(-50%, -50%);
}

.table-wrapper{
  width: 100%;
  overflow-x: auto;
}

.details-table-custom{
  min-width: 1400px;
}

.d-print-none {
  display: block;
}

@media print {

  .d-print-none {
    display: none;
  }

}

</style>